import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import SidebarCard from "./components/SidebarCard";
import routes from "routes";

const Sidebar = (props: {
  open: boolean;
  onClose: () => void; 
}) => {
  const { open, onClose } = props;
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[50px] mt-[50px] flex items-center`}>
        <div className="font-poppins text-[26px] font-bold text-navy-700">
          CONTROLFOODS<span className="font-medium"></span>
        </div>
      </div>

      <div className="mt-[58px] mb-7 h-px bg-gray-300" />

      <ul className="mb-auto pt-1">
        <Links routes={routes} onLinkClick={onClose} />
      </ul>

      <div className="flex justify-center">
        <SidebarCard />
      </div>

    </div>
  );
};

export default Sidebar;
